import type { Color } from "@salestrak/ui";
import { STAGE_TYPES, type StageType } from "#app/lib/data";

/** The four stage categories in pipeline order: not started, underway,
 *  landed, stopped. A chart of categories reads in this order, never ranked
 *  by count — the order IS the pipeline. */
export const STAGE_TYPE_ORDER: readonly StageType[] = STAGE_TYPES;

/** The semantic color of each category — not-started grey, active blue,
 *  landed green, stopped red. A new stage starts on its category's color
 *  (kept in lockstep with the server's `createDefaults` seeds in
 *  `stages.service.ts`), and a category slice in a chart wears it, so the two
 *  agree about what each band means. */
export const STAGE_TYPE_COLOR: Record<StageType, Color> = {
  pending: "dark-grey",
  inProgress: "blue",
  done: "green",
  canceled: "red",
};
